package es.subastia.domain.model

data class LotDomainModel(
    val assetId: String,
    val catastralRef: String? = null,
    val description: String? = null,
    val address: String? = null,
    val city: String? = null,
    val province: String? = null,
    val postcode: String? = null,
    val visitable: String? = null,
    val charges: String? = null,
    val registryData: String? = null,
    val possessionStatus: String? = null,
    val additionalInfo: String? = null,
    val appraisalValue: Double? = null,
    val auctionValue: Double? = null,
    val depositAmount: Double? = null,
    val bidStep: Double? = null,
    val minBid: Double? = null,
    val lastUpdate: String? = null,
    val imageUrl: String? = null,
    val mapImageUrl: String? = null,
    val latitude: Double? = null,
    val longitude: Double? = null
)
